import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  ICONS_WEB,
} from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Box, Tooltip } from "@mui/material";
import { OrderForceCloseoutCard } from "../OrderForceCloseoutCard/OrderForceCloseoutCard";

/**
 * A component that displays a button with a hoverable tooltip containing order information for force closeout.
 *
 * @param {Object} props - Component props.
 * @param {Object} props.order - The order object containing information to be displayed in the tooltip.
 *
 * @returns {JSX.Element} The rendered component with a button and a hoverable tooltip.
 *
 * @example
 * <OrderForceCloseoutPopper order={order} />
 */
export const OrderForceCloseoutPopper = memo(({ order }) => {
  const { classes } = useStyles();

  return (
    <Tooltip
      title={<OrderForceCloseoutCard order={order} />}
      slotProps={{
        popper: {
          placement: "right",
          modifiers: [
            {
              name: "offset",
              options: { offset: [0, -18] },
            },
          ],
          sx: { p: 0, m: 0 },
        },
        tooltip: { sx: { p: 0, m: 0 } },
      }}
    >
      <Box>
        <MiButton
          size="small"
          className={classes.infoButton}
          color={BUTTON_COLORS.ORANGE}
          variant={BUTTON_VARIANTS.CONTAINED}
          startIcon={{ path: mdi[ICONS_WEB.ACCOUNT_LOCK_OPEN], iconSize: 0.5 }}
        />
      </Box>
    </Tooltip>
  );
});

const useStyles = makeStyles()((theme) => ({
  infoButton: {
    padding: theme.spacing(0.5, 1.5),
    marginLeft: theme.spacing(1),
  },
}));
